/**
 * The UI-v2 sizing system.
 *
 * v1 IS RETIRED. The `:where(html:not(.ui-v2))` rules it needed were deleted from src/App.css on
 * 2026-09-28, so there is no longer a second sizing system to switch to - asking for it would
 * render an app with neither rule set, which is worse than either. `?ui=v1` is therefore accepted
 * and ignored rather than honoured: old links, bookmarks and a stored preference from the
 * migration all still open a working app.
 *
 * `html.ui-v2` stays on the element and the 84 rules keep their prefix. Stripping it would drop
 * their specificity from 0,1,1 to 0,1,0 in 84 places, which is a cascade change for no benefit.
 *
 * This file is now a single unconditional call. It is kept rather than inlined into main.tsx so
 * the class name lives in one place, and so `isUiV2()` - still imported by AppTable, HeaderBar,
 * SidebarMenu, DashboardLayout, LocaleProvider and antdTheme - keeps working while those call
 * sites are collapsed. Deleting it is the last step of that cleanup, not this one.
 */

const CLASS_NAME = 'ui-v2';

/** Puts the class on <html>. Call once at boot, before the first render. */
export const applyUiVersion = (): void => {
  document.documentElement.classList.add(CLASS_NAME);
};

/**
 * True whenever the class is present, which is always in the running app.
 *
 * Still a real DOM read rather than a hard `true`: unit tests mount these components without the
 * boot step, and answering `true` there would claim a sizing system the test's DOM has not got.
 */
export const isUiV2 = (): boolean =>
  typeof document !== 'undefined' && document.documentElement.classList.contains(CLASS_NAME);
